/* Manage Admin */
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_FAIL = "API_RESPONSE_FAIL";
export const GET_SPECIAL_DATES = "GET_SPECIAL_DATES";
export const ADD_SPECIAL_DATES = "ADD_SPECIAL_DATES";
export const UPDATE_SPECIAL_DATES = "UPDATE_SPECIAL_DATES";
export const DELETE_SPECIAL_DATES = "DELETE_SPECIAL_DATES";

export const GET_EXPORT_SPECIAL_DATES = "GET_EXPORT_SPECIAL_DATES";
export const GET_EXPORT_SPECIAL_DATES_SUCCESS = "GET_EXPORT_SPECIAL_DATES_SUCCESS";
export const GET_EXPORTED_SPECIAL_DATES_FAIL = "GET_EXPORTED_SPECIAL_DATES_FAIL";
export const RESET_EXPORT_DATA = "RESET_EXPORT_DATA";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
